<template>
    <router-link :to="to" class="brochure">
        <p v-html="label" />
        <div>
            <span>{{ $t('richiedi') }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24.042" height="24.042" viewBox="0 0 24.042 24.042">
                <g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(11.769 1.666) rotate(45)">
                    <path id="Unione_1" data-name="Unione 1" d="M7.977,16.784a.738.738,0,0,1,0-1.046l6.5-6.5H.738a.739.739,0,0,1,0-1.478H14.476l-6.5-6.5A.739.739,0,1,1,9.021.217l7.761,7.76a.739.739,0,0,1,.136.186h0l.007.015v0l.006.013v0l.006.013,0,0,0,.011,0,.007,0,.01,0,.008,0,.008,0,.01,0,.007,0,.01,0,.007,0,.011v.005l0,.012v.005l0,.012v.006l0,.012v.006l0,.012V8.38l0,.011v.027s0,.005,0,.008v.018s0,.009,0,.013,0,0,0,0,0,.011,0,.017v0c0,.006,0,.012,0,.019h0s0,.007,0,.01a.069.069,0,0,1,0,.007.736.736,0,0,1-.232.521L9.021,16.784a.74.74,0,0,1-1.044,0Z" transform="translate(-1 -1.356)" fill="#fff"/>
                </g>
            </svg>
        </div>
    </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/mixins/breakpoints";

  .brochure{
    display: inline-block;
    position: relative;
    cursor: pointer;
    outline: 0;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    text-align: left;
    text-decoration: none;
    border-bottom: 2px solid #343434;
    padding: 28px 75px 28px 35px;
    background: transparent linear-gradient(113deg, #30AE8D 0%, #5DE067 100%) 0% 0% no-repeat padding-box;
      @media #{$large_mq_max} {
        margin-top: 80px;
    }

    p {
        font-size: 1.25rem;
        color: #FFF;
        font-family: 'IBM Plex Mono', sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        margin: 0 0 40px;
        @media #{$medium_mq} {
            font-size: 1.35rem;
            margin: 0 0 50px;
        }
        @media #{$large_mq} {
            font-size: 1.45rem;
        }
        @media #{$xlarge_mq} {
            font-size: 1.65rem;
            margin: 0 0 60px;
        }
        @media #{$xlarge_mq} {
            font-size: 1.875rem;
        }
    }
    span {
        font-size: .9rem;
        color: #FFF;
        font-family: 'IBM Plex Mono', sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: .05rem;
        @media #{$large_mq} {
            font-size: 1.05rem;
        }
        @media #{$xlarge_mq} {
            font-size: 1.125rem;
        }
    }
    svg{
      width: 24px;
      height: 24px;
      transform: rotate3d(0, 0, 1, 0);
      transition: transform .8s cubic-bezier(.23,1,.32,1);
      position: absolute;
      top: calc(50% - 12px);
      left: 100px;
      @media #{$large_mq} {
        left: 130px;
      }
    }
    &:hover{
        background: transparent linear-gradient(113deg, #30AE8D 0%, #5DE067 50%) 0% 0% no-repeat padding-box;
    }
    &:hover svg{
      transform: rotate3d(0, 0, 1, -45deg);
      transition-delay: .2s;
    }
  }
</style>
